import { createStore } from "vuex";

export default createStore({
  state: {
    userInfo: {},
    isAdd: false,
  },
  getters: {
    getState(state, getters) {
      console.log(state)
      return state.isAdd;
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});
